import { render, staticRenderFns } from "./ResponsiveWave.vue?vue&type=template&id=7ad5f2cf&scoped=true&"
import script from "./ResponsiveWave.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveWave.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveWave.vue?vue&type=style&index=0&id=7ad5f2cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad5f2cf",
  null
  
)

export default component.exports